import React from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';

import useFetch from '@api/hooks/useFetch';
import AccountClientRequests from '@api/requests';

import { isVerificationAccount } from '@app/redux/auth/auth.selectors';
import { useAppSelector } from '@app/redux/hooks';
import RoutePaths from '@app/routes/paths';
import useGenerateRoutePath from '@app/routes/paths/useGenerateRoutePath';

import { Grid } from '@mui/material';

import Loader from '@components/loader';

import EnableEmail2FA from './components/EnableEmail2FA';
import EnablePhone2FA from './components/EnablePhone2FA';
import EnableTOTP2FA from './components/EnableTOTP2FA';
import EnableWebAuthn2FA from './components/EnableWebAuthn2FA';
import MFASelector from './components/MFASelector';
import MFA_METHODS_ENUM from './enums/MFA_METHODS.enum';
import { mapAvailableMFAMethods } from './helpers/mapAvailableMFAMethods';

const MFASetupMethods = {
	[MFA_METHODS_ENUM.WEBAUTHN]: EnableWebAuthn2FA,
	[MFA_METHODS_ENUM.EMAIL]: EnableEmail2FA,
	[MFA_METHODS_ENUM.SMS]: EnablePhone2FA,
	[MFA_METHODS_ENUM.TOTP]: EnableTOTP2FA,
};

function MFASetupPage() {
	const { selectedMFA } = useLocation<{ selectedMFA?: MFA_METHODS_ENUM } | undefined>().state || {};
	const { data: mfaMethods, loading } = useFetch(AccountClientRequests.MFA.getMFAMethods, [], undefined);
	const { needVerifyAccount } = useAppSelector(isVerificationAccount);
	const generateRoutePath = useGenerateRoutePath();
	const history = useHistory();

	if (needVerifyAccount) return <Redirect to={generateRoutePath(RoutePaths.VERIFICATION.ACCOUNT)} />;
	else if (loading)
		return (
			<Grid container alignItems={'center'} justifyContent={'center'} sx={{ height: '100%' }}>
				<Loader />
			</Grid>
		);
	else if (selectedMFA) {
		const onDecline = () => history.push(history.location.pathname, { selectedMFA: undefined });
		const MFASetupMethod = MFASetupMethods[selectedMFA];

		return <MFASetupMethod onDecline={onDecline} />;
	} else return <MFASelector availableMFAMethods={mapAvailableMFAMethods(mfaMethods)} />;
}

export default MFASetupPage;
